module.exports = __webpack_public_path__ + "static/img/rule_bottom.fa20a843.png";